import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-taupe-light py-8 text-center text-cream/60 font-body text-sm" data-id="element-14">
        <div className="max-w-7xl mx-auto px-4" data-id="element-15">
          <p className="mb-3" data-id="element-16">
            © {new Date().getFullYear()} Metabolismo Silver 21. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-17">
            <button onClick={() => setPrivacyOpen(true)} className="underline underline-offset-2 hover:text-cream transition-colors" data-id="element-18">
              Política de Privacidad
            </button>
            <span className="opacity-40" data-id="element-19">|</span>
            <button onClick={() => setTermsOpen(true)} className="underline underline-offset-2 hover:text-cream transition-colors" data-id="element-20">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs max-w-2xl mx-auto opacity-70" data-id="element-21">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de comenzar cualquier programa de nutrición o
            ejercicio.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-22">
        <p className="text-taupe font-semibold" data-id="element-23">
          Última actualización: Marzo 2026
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-24">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-25">
          Al adquirir nuestro producto digital "Metabolismo Silver 21",
          recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito directamente; todos los
          pagos son procesados por plataformas de pago seguras con encriptación
          SSL.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-26">
          2. Uso de la Información
        </h3>
        <p data-id="element-27">Tu información personal se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-28">
          <li data-id="element-29">Procesar y entregar tu compra digital.</li>
          <li data-id="element-30">Enviarte el enlace de descarga y confirmación de compra.</li>
          <li data-id="element-31">Comunicarnos contigo en caso de problemas con tu pedido.</li>
        </ul>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-32">
          3. Protección de Datos
        </h3>
        <p data-id="element-33">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Utilizamos encriptación SSL en
          todas las transacciones.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-34">
          4. Compartir Información
        </h3>
        <p data-id="element-35">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          necesarios para procesar tu transacción.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-36">
          5. Cookies
        </h3>
        <p data-id="element-37">
          Nuestro sitio web puede utilizar cookies para mejorar tu experiencia
          de navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto podría afectar algunas funcionalidades del sitio.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-38">
          6. Tus Derechos
        </h3>
        <p data-id="element-39">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar la limitación
          del tratamiento de tus datos o ejercer tu derecho a la portabilidad de
          los mismos.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-40">
          7. Cambios en esta Política
        </h3>
        <p data-id="element-41">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Cualquier cambio será publicado en esta página con
          la fecha de actualización correspondiente.
        </p>
      </Modal>

      {/* Terms & Conditions Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-42">
        <p className="text-taupe font-semibold" data-id="element-43">
          Última actualización: Marzo 2026
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-44">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-45">
          Al acceder a este sitio web y/o adquirir el producto digital
          "Metabolismo Silver 21", aceptas cumplir con estos términos y
          condiciones de uso. Si no estás de acuerdo con alguno de estos
          términos, te rogamos que no utilices nuestro sitio ni adquieras
          nuestros productos.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-46">
          2. Naturaleza del Producto
        </h3>
        <p data-id="element-47">
          "Metabolismo Silver 21" es un producto digital informativo (eBook) que
          proporciona orientación general sobre bienestar y hábitos saludables.
          Este producto NO constituye consejo médico, diagnóstico ni
          tratamiento. Siempre consulta a un profesional de la salud calificado
          antes de iniciar cualquier programa de nutrición o ejercicio.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-48">
          3. Producto Digital y Entrega
        </h3>
        <p data-id="element-49">
          Al completar tu compra, recibirás acceso inmediato al contenido
          digital. Dado que se trata de un producto digital de descarga
          instantánea, comprendes que el acceso se otorga de forma inmediata
          tras la confirmación del pago.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-50">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-51">
          Todo el contenido de "Metabolismo Silver 21", incluyendo textos,
          gráficos, imágenes y diseño, está protegido por derechos de autor. Se
          concede una licencia personal e intransferible para uso individual.
          Queda prohibida la reproducción, distribución, modificación o reventa
          del contenido sin autorización expresa por escrito.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-52">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-53">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos de pérdida de peso ni mejoras de salud. El
          contenido se proporciona "tal cual" con fines informativos y
          educativos. No nos hacemos responsables de decisiones tomadas
          basándose en la información proporcionada en el producto.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-54">
          6. Descargo Médico
        </h3>
        <p data-id="element-55">
          La información contenida en este producto no pretende sustituir la
          relación con un médico o profesional de la salud. Cualquier decisión
          relacionada con tu salud debe ser tomada en consulta con un
          profesional cualificado. Si tienes alguna condición médica
          preexistente, consulta a tu médico antes de seguir cualquier
          recomendación de este programa.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-56">
          7. Modificaciones
        </h3>
        <p data-id="element-57">
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación en el sitio web. El uso continuado del sitio
          después de dichos cambios constituye tu aceptación de los nuevos
          términos.
        </p>

        <h3 className="font-heading text-lg font-bold text-taupe mt-4" data-id="element-58">
          8. Ley Aplicable
        </h3>
        <p data-id="element-59">
          Estos términos y condiciones se rigen por las leyes aplicables en la
          jurisdicción correspondiente. Cualquier disputa será resuelta en los
          tribunales competentes de dicha jurisdicción.
        </p>
      </Modal>
    </>;
}